export default {"src":"/_next/static/media/settings-menu.3f9e918d.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};